import range from "lodash.range";

import { formatDayOfWeek } from "services/formatDayOfWeek";

export function getDayOfWeekOptions(selectedValues?: number[]) {
	return range(1, 8).map(dayOfWeek => ({
		id: dayOfWeek + "",
		value: dayOfWeek,
		text: formatDayOfWeek(dayOfWeek),
		selected: !!selectedValues && selectedValues.includes(dayOfWeek)
	}));
}
